import Nullstack from 'nullstack';
export default function IconStretching({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-stretching",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "16",
    cy: "5",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M5 20l5 -.5l1 -2"
  }), "   ", Nullstack.element("path", {
    d: "M18 20v-5h-5.5l2.5 -6.5l-5.5 1l1.5 2"
  }), " ");
}